<template>
  <!-- eslint-disable -->
<svg class="fertility-state-inseminated-regular-crv crv-svg-icon"  xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 22 22">
    <path fill-rule="evenodd" d="M11,2 C15.9705627,2 20,6.02943725 20,11 C20,15.9705627 15.9705627,20 11,20 C6.02943725,20 2,15.9705627 2,11 C2,6.02943725 6.02943725,2 11,2 Z M11,4 C7.13400675,4 4,7.13400675 4,11 C4,14.8659932 7.13400675,18 11,18 C14.8659932,18 18,14.8659932 18,11 L17.999,10.974 L11.025,10.975 L11.0241529,4.00004079 C11.0161051,4.0000136 11.0080542,4 11,4 Z"/>
  </svg>
<!-- eslint-enable -->
</template>